export default "__VITE_ASSET__CEc5spAz__"